/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import config from '../../../config';
import { useThemeMode } from '@features/theme/context/ThemeContext';
import { useAppSelector } from '@reducers/index';
import { isStaff } from '@selectors/user';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import './styles.scss';

export const DarkModeToggle = () => {
  const isUserStaff = useAppSelector(isStaff);
  const { isDarkMode, toggleMode } = useThemeMode();

  if (!config.features.darkMode || !isUserStaff) {
    return null;
  }

  const tooltipText = isDarkMode ? 'Switch to light mode' : 'Switch to dark mode';
  const icon = isDarkMode ? 'fa-moon' : 'fa-brightness';

  return (
    <SimpleTooltip text={tooltipText}>
      <div
        className={`dark-mode-toggle-switch ${isDarkMode ? 'dark' : 'light'}`}
        onClick={toggleMode}
        role='button'
        tabIndex={0}
        aria-label={tooltipText}
      >
        <div className='toggle-thumb'>
          <i className={`fal ${icon}`} />
        </div>
      </div>
    </SimpleTooltip>
  );
};
